module.exports = __webpack_public_path__ + "static/media/phone_book.3e2e4ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/web_apps/phone_book.png
// module id = 132
// module chunks = 0